module.exports = __webpack_public_path__ + "static/img/404.a57b6f3.png";